import React, { Component } from "react";
import PropTypes from "prop-types";

import "../../../styles/components/utils/components/Slider.scss";

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="slider" className="slider-container">
        <div
          className="filled-track"
          style={{
            width: `calc(${this.props.value / this.props.max} * (100% - 30px) + 30px)`,
          }}
        />
        <input
          type="range"
          min={this.props.min}
          max={this.props.max}
          step={this.props.step || 0.1}
          className="slider"
          value={this.props.value}
          onChange={e => this.props.onChange(e.target.value, e)}
        />
        <p
          className={
            "value-label " + (this.props.value / this.props.max < 0.25 ? "no-transition" : "")
          }
          style={{
            left:
              this.props.value / this.props.max < 0.25
                ? `calc(${this.props.value / this.props.max} * (100% - 30px) + 30px + 0.75rem)`
                : "1rem",
          }}
        >
          {this.props.value + this.props.unit}
        </p>
      </div>
    );
  }
}

Slider.propTypes = {
  value: PropTypes.any,
  min: PropTypes.number,
  max: PropTypes.number,
  unit: PropTypes.string,
  onChange: PropTypes.func,
};

export default Slider;
